<!--
    Kobra Cutplace
    Example Search:
    - https://cdn.statcdn.com/static/kobra/infotype.json
-->

<template>
    <div>
        <div class="margin-bottom-10">
            <h3 class="entity__headline">
                Suchtyp
            </h3>
            <div>
                <select
                    id="kobraSearchtype"
                    v-model="selectedSearchType"
                    name="kobraSearchType">
                    <option
                        value="sworte"
                        selected>
                        Schlagwort
                    </option>
                    <option value="id_brkey">
                        Branchengruppenschlüssel
                    </option>
                </select>
            </div>
        </div>
        <div class="margin-bottom-10">
            <h3 class="entity__headline">
                Branchengruppe
            </h3>
            <div>
                <select
                    id="kobraBranchgroups"
                    v-model="selectedBranchGroup"
                    name="kobraBranchgroups">
                    <option
                        v-for="(item, index) in branchgroups"
                        :key="index"
                        :value="item.id_brgrp">
                        {{ item.titel }}
                    </option>
                </select>
            </div>
        </div>

        <div class="margin-bottom-10">
            <h3 class="entity__headline">
                Informationstyp
            </h3>
            <div
                v-for="(item, index) in infotypes"
                :key="index">
                <label class="entity__label">
                    <input
                        :id="`kobraInfotype_${ index }`"
                        v-model="selectedInfoType"
                        type="radio"
                        :value="item.id_typ"
                        name="kobraInfotype"
                        class="entity__checkbox">
                    <img
                        :src="item.url_icon"
                        class="margin-right-5 vertical-middle" />
                    {{ item.titel }}
                </label>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';
    import qs from 'qs';
    import axios from 'axios';
    import testLocalStorage from '../components/testLocalStorage.js';
    import { useGetters } from 'composables/useVuex';

    export default Vue.component('KobraFilter', {
        data: function() {
            return {
                infotypes: {},
                branchgroups: {},
                selectedBranchGroup: 'A00',
                selectedInfoType: 'A00',
                selectedSearchType: 'sworte',
            };
        },
        watch: {
            selectedBranchGroup(newValue) {
                this.$emit('changebranchgroup', newValue);
            },
            selectedInfoType(newValue) {
                this.$emit('changeinfotype', newValue);
            },
            selectedSearchType(newValue) {
                this.$emit('changesearchtype', newValue);
            },
        },
        methods: {
            updateParametersFromUri() {
                const parameters = qs.parse(window.location.search.substring(1));
                if ('branchGroup' in parameters) {
                    this.selectedBranchGroup = parameters.branchGroup;
                }
                if ('infoType' in parameters) {
                    this.selectedInfoType = parameters.infoType;
                }
            },
        },
        created() {

            if (Object.prototype.hasOwnProperty.call(this.$store.state.searchQueryParameters, 'branchGroup')) {
                this.selectedBranchGroup = this.$store.state.searchQueryParameters.branchGroup;
            }
            if (Object.prototype.hasOwnProperty.call(this.$store.state.searchQueryParameters, 'infoType')) {
                this.selectedInfoType = this.$store.state.searchQueryParameters.infoType;
            }
            if (Object.prototype.hasOwnProperty.call(this.$store.state.searchQueryParameters, 'searchType')) {
                this.selectedSearchType = this.$store.state.searchQueryParameters.searchType;
            }
            if (this.hasKcs) {
                const urlBrGroup = document.getElementById('kobraApiBrgroups').getAttribute('data-route');
                const urlInfotype = document.getElementById('kobraApiInfotypes').getAttribute('data-route');

                if (!testLocalStorage()) {
                    axios.get(urlInfotype).then(response => {
                        this.infotypes = response.data;
                    });
                    axios.get(urlBrGroup).then(response => {
                        this.branchgroups = response.data;
                    });
                } else {
                    const infotypes = window.localStorage.getItem('infotypes');
                    const brgroups = window.localStorage.getItem('brgroups');

                    if (infotypes) {
                        this.infotypes = JSON.parse(infotypes);
                    } else {
                        axios.get(urlInfotype).then(response => {
                            this.infotypes = response.data;
                            window.localStorage.setItem('infotypes', JSON.stringify(response.data));
                        });
                    }

                    if (brgroups) {
                        this.branchgroups = JSON.parse(brgroups);
                    } else {
                        axios.get(urlBrGroup).then(response => {
                            this.branchgroups = response.data;
                            window.localStorage.setItem('brgroups', JSON.stringify(response.data));
                        });
                    }
                }
            }
        },
        setup() {
            const getters = {
                ...useGetters('globalSettings', [
                    'hasKcs']),
            };

            return {
                ...getters,
            };
        },
    });

</script>
